import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./shippingChargeSlice";

export const selectDomain = state => state.shippingCharge || initialState;

export const makeSelectAll = createSelector(
    selectDomain,
    state => state.all,
);

export const makeSelectOne = createSelector(
    selectDomain,
    state => state.one,
);

export const makeSelectQuery = createSelector(
    selectDomain,
    state => state.query,
);

export const makeSelectWeightPrice = createSelector(
    selectDomain,
    state => state.one.weight_price,
);